import {
  BORDER_DIRECTIONS,
  BorderSpecificProperty,
  getBorderProperty,
} from '../constants';

const composeBorderSpecificProperty =
  (property: BorderSpecificProperty) =>
  (values: Record<string, string | null>): string | null => {
    const propertyValues = BORDER_DIRECTIONS.map(
      (direction) => values[getBorderProperty(direction, property)],
    ).filter(Boolean);

    if (propertyValues.length === 0) {
      return null;
    }

    // If all sides have the same value, return just that value
    const firstValue = propertyValues[0];
    if (propertyValues.every((value) => value === firstValue)) {
      return firstValue;
    }

    // Return space-separated values for different sides
    return propertyValues.join(' ');
  };

const composeBorderProperty =
  (
    direction:
      | (typeof BORDER_DIRECTIONS)[number]
      | 'InlineStart'
      | 'InlineEnd'
      | '',
  ) =>
  (values: Record<string, string | null>): string | null => {
    const width = values[getBorderProperty(direction, 'Width')];
    const style = values[getBorderProperty(direction, 'Style')];
    const color = values[getBorderProperty(direction, 'Color')];

    const parts = [];
    if (width) {
      parts.push(width);
    }
    if (style) {
      parts.push(style);
    }
    if (color) {
      parts.push(color);
    }

    return parts.join(' ');
  };

export const borderComposeMap = {
  border: composeBorderProperty(''),
  borderTop: composeBorderProperty('Top'),
  borderRight: composeBorderProperty('Right'),
  borderBottom: composeBorderProperty('Bottom'),
  borderLeft: composeBorderProperty('Left'),
  borderInlineStart: composeBorderProperty('InlineStart'),
  borderInlineEnd: composeBorderProperty('InlineEnd'),
  borderStyle: composeBorderSpecificProperty('Style'),
  borderWidth: composeBorderSpecificProperty('Width'),
  borderColor: composeBorderSpecificProperty('Color'),
};
